import axios from 'axios'
import {Message} from "element-ui";
import router from "../router";
import { app } from '@/main'

const request = axios.create({
  baseURL: 'https://dogtag.petheylife.com/api',  // 注意！！ 这里是全局统一加上了 '/api' 前缀，也就是说所有接口都会加上'/api'前缀在，页面里面写接口的时候就不要加 '/api'了，否则会出现2个'/api'，类似 '/api/api/user'这样的报错，切记！！！
   // baseURL: 'https://pethey.beiniuai.com/api',  // 注意！！ 这里是全局统一加上了 '/api' 前缀，也就是说所有接口都会加上'/api'前缀在，页面里面写接口的时候就不要加 '/api'了，否则会出现2个'/api'，类似 '/api/api/user'这样的报错，切记！！！
  timeout: 120000
})

// request 拦截器
// 可以自请求发送前对请求做一些处理
// 比如统一加token，对请求参数统一加密
request.interceptors.request.use(config => {
  config.headers['Content-Type'] = 'application/json;charset=utf-8';
  // en-US  fr-FR
  const lang = (app.$i18n && app.$i18n.locale) || (navigator.languages && navigator.languages[0]) || navigator.language || 'fr-FR'
  config.headers['lang'] = ['en-US', 'fr-FR'].includes(lang) ? lang : 'fr-FR'

  if (localStorage.getItem('Authorization')) {
    config.headers['Authorization'] = localStorage.getItem('Authorization')
  }
  // config.headers['token'] = user.token;  // 设置请求头
  return config
}, error => {
  return Promise.reject(error)
});

// response 拦截器
// 可以在接口响应后统一处理结果
request.interceptors.response.use(
  response => {
    let res = response.data;

    if (res.code === 200) {
      res.token && localStorage.setItem('Authorization', res.token)
      return res
    }

    // 身份认证失败
    if (res.code === 401) {
      if (!res.msg.startsWith('请求访问')) {
        Message({
          message: res.msg,
          type: 'error',
          duration: 3 * 1000
        });
      }
      localStorage.removeItem('Authorization')
      localStorage.removeItem('banner')
      localStorage.removeItem('link')
      localStorage.removeItem('user')
      router.push('/');
      return Promise.reject('Authorize Failed')
    }

    // 如果是返回的文件
    if (response.config.responseType === 'blob') {
      return res
    }

    // 兼容服务端返回的字符串数据
    if (typeof res === 'string') {
      res = res ? JSON.parse(res) : res
    }

    return res;
  },
  error => {
    console.log('err' + error) // for debug
    return Promise.reject(error)
  }
)


export default request




// WEBPACK FOOTER //
// ./src/utils/request.js